import { ConsentApprovalModule } from './consent-approval.module';

export { ConsentApprovalErrorInterceptor } from './consent-approval.interceptor';
export { CONSENT_APPROVAL_PATH } from './consent-approval.config';
export default ConsentApprovalModule;
